import { ProductType } from "@obg/ngx.core";

export const GAMES_OF_CHANCE_ROUTES = [
	ProductType.Casino,
	ProductType.LiveCasino,
	ProductType.Poker,
	"poker-migration",
];

export const SPORTSBOOK_ROUTES = [ProductType.Sportsbook];

export const HAMPI_ROUTE_NOT_ALLOWED_ALERT_ID = "HAMPI_ROUTE_NOT_ALLOWED_ALERT_ID";
